<!-- Main Error Wrapper Start -->
<div class="error-main-wrapper" [ngClass]="{'full-height': showFullPage}">
  <div class="error-inner-content">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-8">
          <h2 class="error-title font-weight-bold">Oops!</h2>
          <h5 class="error-sub-title font-weight-bold">
            We can't find the page you're looking for.
          </h5>
          <div class="error-description"><p>Error: 404</p></div>
          <a href="javascript:;" class="btn btn-primary" (click)="goBack()">Go Back</a>
        </div>
        <div class="col-lg-4 py-5">
          <img class="img-fluid" src="assets/images/error/404.png" />
        </div>
      </div>
    </div>
  </div>
</div>
